// src/components/dashboard/widgets/school-holidays-widget.tsx
import { useEffect, useState } from 'react';
import { GraduationCap } from 'lucide-react';
import { supabase } from '@/src/lib/supabase';
import { useAppColors } from '@/src/lib/theme';

interface SchoolHoliday { name: string; start_date: string; end_date: string }

function formatRange(start: string, end: string): string {
  const s = new Date(`${start}T00:00:00`);
  const e = new Date(`${end}T00:00:00`);
  const opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short' };
  return `${s.toLocaleDateString('en-AU', opts)} – ${e.toLocaleDateString('en-AU', opts)}`;
}

export default function SchoolHolidaysWidget() {
  const c = useAppColors();
  const [holidays, setHolidays] = useState<SchoolHoliday[] | undefined>(undefined);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    supabase
      .from('school_holidays')
      .select('name, start_date, end_date')
      .gte('end_date', today)
      .order('start_date', { ascending: true })
      .limit(2)
      .then(({ data }) => setHolidays(data ?? []));
  }, []);

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="rounded-2xl border p-4 bg-warm-gray border-leaf-500/20 h-full">
      <div className="flex items-center justify-between mb-3">
        <div className="w-8 h-8 rounded-lg bg-leaf-500/10 flex items-center justify-center">
          <GraduationCap size={15} className="text-leaf-400" />
        </div>
        <span className="text-[9px] font-bold tracking-widest text-cream-muted/50 uppercase">School holidays</span>
      </div>
      {holidays === undefined ? (
        <div className="text-xs text-cream-muted/50">Loading…</div>
      ) : holidays.length === 0 ? (
        <div className="text-xs text-cream-muted/50">None coming up</div>
      ) : (
        <div className="space-y-2.5">
          {holidays.map((h) => {
            const inProgress = h.start_date <= today && h.end_date >= today;
            return (
              <div key={h.name}>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs text-cream">{h.name}</span>
                  {inProgress && <span className="text-[9px] font-bold text-leaf-400 uppercase">Now</span>}
                </div>
                <div className="text-[10px] text-cream-muted">{formatRange(h.start_date, h.end_date)}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}